import React from 'react';
import { styled } from '@linaria/react';
import { Announcer, IconButton } from 'clad-ui';
import dynamic from 'next/dynamic';
import { ArrowLeft } from 'clad-ui/icons';
const PolicyLinks = dynamic(() => import('./IDLayout/PolicyLinks'));
type Props = {
  children?: (JSX.Element | boolean)[] | JSX.Element;
  showPolicyLinks?: boolean;
  onBack?: () => void;
};
const Box = (props: Props) => {
  const {
    children,
    showPolicyLinks = true,
    onBack
  } = props;
  return <div className={boxCss}>
      {onBack ? <IconButton onClick={onBack} extraClasses={backButtonCss} variant="outline" color="neutral">
          <ArrowLeft />
        </IconButton> : null}

      {children}

      {showPolicyLinks ? <>
          <div className={brCss} />
          <PolicyLinks />
        </> : null}
    </div>;
};
const backButtonCss = "b1jo9r3w";
const brCss = "b1m0spb5";
Box.Title = /*#__PURE__*/styled('h3')({
  name: "Box2",
  class: "bgcibuc",
  propsAsIs: false
});
Box.Note = /*#__PURE__*/styled('p')({
  name: "Box3",
  class: "beaihe5",
  propsAsIs: false
});
Box.ErrorArea = function ({
  open,
  message,
  mb,
  mt
}: {
  open?: boolean;
  message?: string;
  mb?: string;
  mt?: string;
}) {
  return open ? <ErrorWrapper mb={mb} mt={mt}>
      <Announcer open type="error">
        {message}
      </Announcer>
    </ErrorWrapper> : null;
};
const _exp14 = /*#__PURE__*/() => ({
  mt
}) => mt ?? '0';
const _exp15 = /*#__PURE__*/() => ({
  mb
}) => mb ?? '20px';
const ErrorWrapper = /*#__PURE__*/styled('div')({
  name: "ErrorWrapper",
  class: "e1i5q6i8",
  propsAsIs: false,
  vars: {
    "e1i5q6i8-0": [_exp14()],
    "e1i5q6i8-1": [_exp15()]
  }
});
const boxCss = "brvnfw";
export default Box;

require("./Box.linaria.module.css");